module.exports = __webpack_public_path__ + "img/cog.c7a78300.svg";